import { getKeys as r } from "./types3.mjs";
import t from "./tokens.json.mjs";
import { compileShadow as c } from "./utils8.mjs";
const e = t.brand, a = () => r(e.FocusRing).reduce(
  (o, s) => {
    const n = e.FocusRing[s].value;
    return o[s] = c(n), o;
  },
  {}
);
export {
  a as compileFocusRingShadows
};
//# sourceMappingURL=compileFocusRingShadows.mjs.map
